export * from 'proxy-target/traps';
export const DELETE = 'delete';
